// import DialogContentText from "@mui/material/DialogContentText";
import {
    FormControl,
    Grid,
    Input,
    InputLabel,
    Typography,
} from '@mui/material';
// import Box from "@mui/material/Box";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { createProject } from '../../../Api/suiviMission/projects';
// import CustomSearchInput from '../CustomSearchInput';

const styles = {
    dialogPaper: {
        minHeight: '70vh',
        maxHeight: '70vh',
    },
};
const defaultValues = {
    title: '',
    missionId: [],
};
function AddProjectModal({ open, handleClose, classes }) {
    AddProjectModal.propTypes = {
        classes: PropTypes.any,
        open: PropTypes.any,
        handleClose: PropTypes.func,
    };
    const [formValues, setFormValues] = React.useState(defaultValues);
    const { i18n } = useTranslation();
    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(e.target.value);
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleCreateProject = (e) => {
        e.preventDefault();
        //api call
        console.log(formValues, classes);
        //  setFormValues({...formValues,[missionId]:value,})
        createProject(formValues);
        //success msg
        handleClose();
    };

    return (
        <React.Fragment>
            {/* <Button variant="outlined" onClick={handleClickOpen}>
          Open max-width dialog
        </Button> */}
            {/* classes={{ paper: classes.dialogPaper }} */}
            <Dialog
                fullWidth={true}
                maxWidth="md"
                maxHeight="md"
                open={open}
                onClose={handleClose}
                scroll='body'
                fullScreen
            >
                <form >
                    <DialogTitle>
                        <Typography align="center">{i18n.t('Nouveau projet')}</Typography>
                    </DialogTitle>
                    <DialogContent>
                        {/* <DialogContentText>
              You can set my maximum width and whether to adapt or not.
            </DialogContentText> */}
                        {/* <Box
              noValidate
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                m: 'auto',
                width: 'fit-content',
              }}
            >

            </Box> */}

                        <Grid container>
                            <Grid
                                item
                                xs={12}
                            >
                                {/* project name input */}
                                <FormControl
                                    fullWidth
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="project-name">
                                        {i18n.t('Nom Du Projet :')}
                                    </InputLabel>
                                    <Input
                                        id="project-name"
                                        value={formValues.title}
                                        name="title"
                                        onChange={handleChange}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                            >
                                {/* <CustomSearchInput
                                    setFormValues={setFormValues}
                                    formValues={formValues}
                                /> */}
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>{i18n.t('Close')}</Button>
                        <Button
                            type='submit'

                            onClick={(e) => handleCreateProject(e)}
                        >{i18n.t('Créer')}</Button>
                    </DialogActions>
                </form>
            </Dialog>

        </React.Fragment>
    );
}

export default withStyles(styles)(AddProjectModal);